import React, { useState } from 'react'

// The same form the home page uses, posting to the same /contact.php. It is
// defined inline in Main.jsx and not exported, so rather than edit that file
// this is a standalone copy. If the endpoint ever changes, change it in both.
//
// `subjectHint` is sent along so a message from Hillary's page can be told
// apart from one sent through the home page.

const ContactForm = ({ subjectHint }) => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' })
  const [submitStatus, setSubmitStatus] = useState(null)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitStatus('submitting')
    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subjectHint ? { ...formData, subject: subjectHint } : formData),
      })
      if (response.ok) {
        setFormData({ name: '', email: '', message: '' })
        setSubmitStatus('success')
        setTimeout(() => setSubmitStatus(null), 5000)
      } else {
        setSubmitStatus('error')
      }
    } catch (error) {
      setSubmitStatus('error')
    }
  }

  return (
    <form onSubmit={handleSubmit} className='contact-form'>
      <div className='form-group' style={{ justifyContent: 'space-between' }}>
        <div>
          <label htmlFor='hillary-name' className='form-label'>Name</label>
          <input
            type='text'
            id='hillary-name'
            name='name'
            value={formData.name}
            onChange={handleChange}
            required
            className='form-input'
            placeholder='Enter your name'
          />
        </div>
        <div>
          <label htmlFor='hillary-email' className='form-label'>Email</label>
          <input
            type='email'
            id='hillary-email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            required
            className='form-input'
            placeholder='Enter your email'
          />
        </div>
      </div>
      <div className='form-group'>
        <label htmlFor='hillary-message' className='form-label'>Message</label>
        <textarea
          id='hillary-message'
          name='message'
          value={formData.message}
          onChange={handleChange}
          required
          className='form-textarea'
          placeholder='Enter your message'
          rows='5'
        ></textarea>
      </div>
      <button type='submit' className='submit-button' disabled={submitStatus === 'submitting'}>
        {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {submitStatus === 'success' && (
        <div className='success-message'>Thank you for your message. We&rsquo;ll get back to you soon!</div>
      )}
      {submitStatus === 'error' && (
        <div className='error-message'>Something went wrong. Please try again, or email us directly.</div>
      )}
    </form>
  )
}

export default ContactForm
